module.exports = __webpack_public_path__ + "img/home_my_value_01.ec2a32c2.png";